import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../../content/utils.js';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import StepMilestonesFormContainer from '../../../containers/portfolio/PortfolioFormContainers/StepMilestonesFormContainer.jsx';

const NewChangeStrategyStepMilestones = ({ slug }) => (
  <>
    <Helmet>
      <title>New {getOrgTermsContent('portfolio')} | ChangeSync</title>
    </Helmet>
    <StepMilestonesFormContainer slug={slug} />
  </>
);

NewChangeStrategyStepMilestones.getInitialProps = ({ query }) => ({
  slug: query.slug,
});
export default requireAuth(withRouterParams(NewChangeStrategyStepMilestones));
